module.exports = __webpack_public_path__ + "img/logo-edd.a12c502e.svg";